import { useState } from "react";
import { ArrowRight, Clock3, Globe2, MessageCircle } from "lucide-react";
import PageHero from "../components/PageHero";
import SectionHeading from "../components/SectionHeading";
import Field from "../components/public/FormField";
import { submitContact } from "../lib/api";

export function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });
  const [state, setState] = useState("idle");
  const handleChange = (event) =>
    setForm({ ...form, [event.target.name]: event.target.value });
  const submit = async (event) => {
    event.preventDefault();
    setState("sending");
    try {
      await submitContact({ ...form, website: "" });
      setState("sent");
    } catch {
      setState("error");
    }
  };
  return (
    <>
      <PageHero
        eyebrow="Contact us"
        title="Tell us what needs to happen."
        copy="Share the context. We will come back with the right next question or next step."
      />
      <section id="content" className="section-space bg-mist">
        <div className="container grid gap-12 lg:grid-cols-[.75fr_1.25fr]">
          <div>
            <SectionHeading
              eyebrow="Start a conversation"
              title="A thoughtful response beats a generic form."
              copy="For pricing information, visit our pricing page. For everything else, send us a message and our team will route it."
            />
            <div className="mt-10 space-y-5 text-sm text-slate">
              <p className="flex gap-3">
                <MessageCircle size={18} className="shrink-0 text-ocean" />
                hello@bridgebyva.com
              </p>
              <p className="flex gap-3">
                <Clock3 size={18} className="shrink-0 text-ocean" />
                Monday–Friday · 9:00–17:00 WAT
              </p>
              <p className="flex gap-3">
                <Globe2 size={18} className="shrink-0 text-ocean" />
                Nigeria · serving clients globally
              </p>
            </div>
          </div>
          <form
            onSubmit={submit}
            className="rounded-3xl border border-ink/10 bg-white p-6 shadow-soft sm:p-8"
          >
            <div className="grid gap-5 sm:grid-cols-2">
              <Field
                label="Name"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
              />
              <Field
                label="Email"
                name="email"
                type="email"
                value={form.email}
                onChange={handleChange}
                placeholder="you@example.com"
              />
              <Field
                label="Phone"
                name="phone"
                required={false}
                value={form.phone}
                onChange={handleChange}
                placeholder="+234..."
              />
              <Field
                label="Subject"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                placeholder="How can we help?"
              />
              <div className="sm:col-span-2">
                <Field
                  label="Message"
                  name="message"
                  type="textarea"
                  value={form.message}
                  onChange={handleChange}
                  placeholder="Tell us a little about what you need."
                />
              </div>
            </div>
            {state === "sent" && (
              <p className="mt-5 rounded-xl bg-bridge/20 p-3 text-sm font-bold text-ink">
                Thanks, your message is with the team. We will be in touch.
              </p>
            )}
            {state === "error" && (
              <p className="mt-5 rounded-xl bg-red-50 p-3 text-sm font-bold text-red-700">
                We could not send that just now. Please email
                hello@bridgebyva.com.
              </p>
            )}
            <button
              type="submit"
              disabled={state === "sending"}
              className="mt-6 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 text-sm font-bold text-white transition hover:bg-navy disabled:cursor-wait disabled:opacity-60"
            >
              {state === "sending" ? "Sending…" : "Send message"}
              <ArrowRight size={16} />
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
